export function leadershipAnchors() {
    $('.team-nav a').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const headerHeight = $('.header').innerHeight();
        const href = $(this).attr('href').slice(1);
        const section = $(`#${href}`);

        $('.team-nav li').removeClass('active');
        $this.parent().addClass('active');
        $("html, body").animate({scrollTop: section.offset().top - headerHeight}, 1000);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/leadershipAnchors.js